module.exports = __webpack_public_path__ + "static/Eyeglasss1_1-2e51152e5d3566b4bae6a37a10e91210.png";